import { GetterTree } from 'vuex'
import { ContentState } from './types'
import { RootState } from '../types'
import config from 'config'

export const getters: GetterTree<ContentState, RootState> = {
  areLoaded: (state: ContentState) => state.loaded,
  isMultiLang: (state: ContentState) => Object.keys(state.contents).length > 1,
  getLanguages: (state: ContentState) => Object.keys(state.contents),
  getContents: (state: ContentState) => state.contents[state.selectedLanguage] ?? Object.values(state.contents)[0],
  currentLangObject: (state: ContentState) => state.languages.find(language => language.key === state.selectedLanguage) || state.languages[0],
  getApiCountry: (state: ContentState) => state.forcedCountry !== null ? state.forcedCountry : state.country,
  getCountries: (state: ContentState) => {
    const countries = !config.content.supportedCountries
      ? state.countries
      : state.countries.filter(country => config.content.supportedCountries.includes(country.key))
    return countries.sort((a, b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0))
  },
  currentCountryObject: (state: ContentState) => state.forcedCountry !== null ? state.countries.find(country => country.key === state.forcedCountry) : state.countries.find(country => country.key === state.country)
}
